import { create } from "zustand";
import { persist } from "zustand/middleware";

import type { AvailableLanguage, BmiForm } from "@/shared/models";
import { AVAILABLE_LANGUAGE, UNIT_SYSTEM } from "@/shared/models";

interface AppSettingsStoreState {
  language: AvailableLanguage;
  unitSystem: BmiForm["unitSystem"];
  isBiometricEnabled: boolean;
  isAmazonChatOpen: boolean;

  setLanguage: (language: AvailableLanguage) => void;
  setUnitSystem: (unitSystem: BmiForm["unitSystem"]) => void;
  setIsBiometricEnabled: (isBiometricEnabled: boolean) => void;
  setIsAmazonChatOpen: (isAmazonChatOpen: boolean) => void;
}

export const useSettingsStore = create<AppSettingsStoreState>()(
  persist(
    (set) => ({
      language: navigator.language.includes("es")
        ? AVAILABLE_LANGUAGE.ES
        : AVAILABLE_LANGUAGE.EN,
      unitSystem: navigator.language.includes("es")
        ? UNIT_SYSTEM.METRIC
        : UNIT_SYSTEM.IMPERIAL,
      isBiometricEnabled: false,
      isAmazonChatOpen: false,

      setLanguage: (language) => set({ language }),
      setUnitSystem: (unitSystem) => set({ unitSystem }),
      setIsBiometricEnabled: (isBiometricEnabled) =>
        set({ isBiometricEnabled }),
      setIsAmazonChatOpen: (isAmazonChatOpen) => set({ isAmazonChatOpen }),
    }),
    {
      name: "settings",
      partialize: ({ language, unitSystem, isBiometricEnabled }) => ({
        language,
        unitSystem,
        isBiometricEnabled,
      }),
    },
  ),
);

export const getSettingsStoreLanguage = () => {
  return useSettingsStore.getState().language;
};
